import React from 'react';

import Modal from 'components/layout/Modal';
import MfaSetForm from 'components/forms/MfaSetForm';

// Pre-submit MFA enrollment blocker. Rendered by MfaChallengeContext when a
// privileged action (send/withdraw) is attempted by a user whose tenant requires
// MFA but who has no verified authenticator. Reuses the onboarding enrollment form
// (MfaSetForm); onSuccess fires once a verified authenticator exists, releasing the
// awaiting caller so the original request can proceed. Dismissing aborts the action.
export default function MfaEnrollmentModal({ open, token, authConfig, onSuccess, onCancel }) {
  return (
    <Modal
      open={open}
      close
      maxWidth={415}
      title={'mfa_setup_required'}
      titleCentered
      onDismiss={onCancel}>
      {open && (
        <MfaSetForm
          authConfig={authConfig}
          tempAuth={{ token }}
          setTempAuth={() => {}}
          onSuccess={onSuccess}
          // Mid-action enrollment, not a sign-in: the login copy's "required
          // to sign in" wouldn't fit here.
          descriptionId="mfa_auth_description_required"
        />
      )}
    </Modal>
  );
}
